import { CircularProgress, Stack } from '@mui/material';

export default function CircularProgressSpinner({ size = 40 }: { size: number }) {
  return (
    <Stack spacing={2} direction="row" alignItems="center">
      <CircularProgress size={size} />
    </Stack>
  );
}
